


import { AgTableClient } from "app/shared/AgTable";
import PageHeader from "app/shared/PageHeader";
import React, { useRef, useState, useEffect } from "react";
import { userInfo } from "app/config/States/users";
import { useRecoilState } from "recoil";
import { ClockCircleOutlined, PlusOutlined, DeleteOutlined, EditOutlined, EyeOutlined, CheckOutlined } from "@ant-design/icons";
import { Button, Modal, Input, Select, TimePicker, Switch, Tooltip, Tag, Space } from "antd";
import axios from "axios";
import "./SaveReport.scss";

const SavedReport = () => {
    const [userDetails, _] = useRecoilState<any>(userInfo);
    const reconPageRef: any = useRef();

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedRow, setSelectedRow] = useState<any>(null);
    const [selectedEmails, setSelectedEmails] = useState<string[]>([]);
    const [showInput, setShowInput] = useState(false);
    const [newEmail, setNewEmail] = useState("");

    // ✅ rowData from API
    const [rowData, setRowData] = useState<any[]>([]);

    const showModal = (row: any) => {
        setSelectedRow(row);
        setIsModalOpen(true);
    };

    const handleCancel = () => {
        setIsModalOpen(false);
    };

    const handleSave = () => {
        setIsModalOpen(false);
    };

    const COLUMN_DEFS = [
        {
            headerName: "Type",
            field: "Type", // not used anymore
            width: 300,
            cellRenderer: () => (
                <Tag style={{ color: "green" }}>
                    Application
                </Tag>
            ),
        },
        {
            headerName: "Report",
            field: "name",
            filter: "agTextColumnFilter",
            enableRowGroup: true,
            enablePivot: true,
            width: 300,
        },
        {
            headerName: "Scheduler",
            field: "scheduler",
            width: 300,
            cellRenderer: (params: any) => (
                <Button
                    type="default"
                    shape="round"
                    size="small"
                    onClick={() => showModal(params.data)}
                    icon={<ClockCircleOutlined style={{ marginLeft: -6, fontSize: 10 }} />}
                >
                    Not scheduled
                </Button>
            ),
        },
        {
            headerName: "Action",
            field: "action",
            width: 300,
            cellRenderer: () => (
                <div style={{ display: "flex", gap: 5, justifyContent: "center" }}>
                    <Button type="text" icon={<EyeOutlined style={{ color: "#1890ff" }} />} onClick={() => {}} />
                    <Button type="text" icon={<EditOutlined style={{ color: "green" }} />} onClick={() => {}} />
                    <Button type="text" icon={<DeleteOutlined style={{ color: "red" }} />} onClick={() => {}} />
                </div>
            ),
        },
    ];

    // ✅ fetch data from API
    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await axios.get("https://stage-apiplatform.finkraftai.com/api/vatTable/getSavedViews", {
                    //moduleId: "VAT Entities Wise Breakup",
                });

                // Make sure response is an array
                setRowData(Array.isArray(response.data?.data) ? response.data.data : []);
            } catch (error) {
                setRowData([]);
            }
        };

        fetchData();
    }, []);







    const [options, setOptions] = useState([{ value: 'test@example.com' }]);
    const [inputVisible, setInputVisible] = useState(false);
    const [inputValue, setInputValue] = useState('');

    const handleAddEmail = () => {
        if (inputValue && !options.find(o => o.value === inputValue)) {
            setOptions([...options, { value: inputValue }]);
        }
        setInputVisible(false);
        setInputValue('');
    };

    const handleChange = (value: any) => {
    };


    return (
        <>
            <PageHeader title="Saved Report" 
            showWorkspaceDropdown={false}
            />

            <div style={{ flex: 1 }}>
                <AgTableClient
                    //@ts-ignore
                    columnDefs={COLUMN_DEFS}
                    groupPanel
                    defaultPivot={[""]}
                    rowData={rowData} // ✅ now dynamic
                    enablePDFViewer
                />
            </div>

            {/* Scheduler Modal */}
            <Modal
                title="Save / Schedule Report"
                className="custom-scheduler-modal"
                open={isModalOpen}
                onCancel={handleCancel}
                footer={[
                    <Button key="cancel" onClick={handleCancel}>
                        Cancel
                    </Button>,
                    <Button key="save" type="primary" onClick={handleSave}>
                        Save
                    </Button>,
                ]}
            >
                <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
                    <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
                        <label style={{ fontWeight: 500 }}>Title</label>
                        <Input placeholder="Title" defaultValue={selectedRow?.Report} />
                    </div>

                    <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '10px' }}>
                        <span style={{ fontWeight: 500 }}>Schedule this report </span><Switch defaultChecked />
                    </div>

                    <div style={{ marginTop: '10px' }}>
                        <label style={{ fontWeight: 500 }}>File name</label>
                        <Input />
                    </div>


                    <div style={{ display: "flex", flexDirection: 'column', gap: 8 }}>

                        <label style={{ fontWeight: 500 }}>Every</label>
                        <div style={{ display: 'flex', justifyContent: "space-between" }}>
                            <Select defaultValue="Month" style={{ width: 120 }}>
                                <Select.Option value="Day">Day</Select.Option>
                                <Select.Option value="Week">Week</Select.Option>
                                <Select.Option value="Month">Month</Select.Option>
                            </Select>


                            <div style={{ display: 'flex', alignItems: 'center', gap: "6px" }}>
                                <label style={{ fontWeight: 500 }}>on</label>
                                <Input defaultValue="1" style={{ width: 60 }} />
                            </div>

                            <div style={{ display: 'flex', alignItems: 'center', gap: "6px" }}>
                                <label style={{ fontWeight: 500 }}>at</label>
                                <TimePicker format="HH:mm" />
                            </div>

                        </div>
                    </div>

                    <div style={{ marginTop: '10px' }}>
                        <label style={{ fontWeight: 500 }}>Timezone</label>
                        <Select defaultValue="UTC" style={{ width: "100%" }}>
                            <Select.Option value="UTC">(UTC+00:00) UTC</Select.Option>
                            <Select.Option value="IST">(UTC+05:30) IST</Select.Option>
                        </Select>
                    </div>


                    <div style={{ display: "flex", flexDirection: "column", gap: 8, marginTop: '10px' }}>
                        <label style={{ fontWeight: 500 }}>Send data by</label>
                        <div style={{ display: 'flex', justifyContent: "space-between" }}>
                            <Select defaultValue="Excel" style={{ width: 100 }}>
                                <Select.Option value="Excel">Excel</Select.Option>
                                <Select.Option value="CSV">CSV</Select.Option>
                            </Select>

                            <div style={{ display: 'flex', alignItems: 'center', gap: "6px" }}>
                                <label style={{ fontWeight: 500 }}>with</label>
                                <Select defaultValue="Current View" style={{ width: 150 }}>
                                    <Select.Option value="Current View">Current View</Select.Option>
                                    <Select.Option value="All Data">All Data</Select.Option>
                                </Select>
                            </div>


                            <div style={{ display: 'flex', alignItems: 'center', gap: "6px" }}>
                                <label style={{ fontWeight: 500 }}>via</label>
                                <Select defaultValue="Email" style={{ width: 100 }}>
                                    <Select.Option value="Email">Email</Select.Option>
                                    <Select.Option value="Download">Download</Select.Option>
                                </Select>
                            </div>
                        </div>
                    </div>

                    {/* <div style={{ marginTop: '10px' }}>
                        <label style={{ fontWeight: 500 }}>Email to</label>
                        <Select placeholder="Choose.." style={{ width: "100%" }}>
                            <Select.Option value="test@example.com">
                                test@example.com
                            </Select.Option>

                          
                            <Select.Option value="add-new" >
                                <span style={{ display: "flex", alignItems: "center", gap: 6 }}>
                                    <PlusOutlined /> Add Email
                                </span>
                            </Select.Option>
                        </Select>
                    </div> */}


                    <div style={{ marginTop: '10px' }}>
                        <label style={{ fontWeight: 500 }}>Email to</label>
                        <Select
                            mode="multiple"
                            placeholder="Choose or type email"
                            style={{ width: '100%' }}
                            value={selectedEmails}
                            onChange={handleChange}
                            dropdownRender={menu => (
                                <div>
                                    {menu}
                                    {inputVisible ? (
                                        <Space style={{ padding: 8 }}>
                                            <Input
                                                size="small"
                                                autoFocus
                                                value={inputValue}
                                                onChange={e => setInputValue(e.target.value)}
                                                onPressEnter={handleAddEmail}
                                                placeholder="Enter email"
                                            />
                                            <Button
                                                type="primary"
                                                size="small"
                                                icon={<CheckOutlined />}
                                                onClick={handleAddEmail}
                                            />
                                        </Space>
                                    ) : (
                                        <Button
                                            type="text"
                                            icon={<PlusOutlined />}
                                            onClick={() => setInputVisible(true)}
                                            style={{ width: '100%', textAlign: 'left', padding: '8px' }}
                                        >
                                            Add new email
                                        </Button>
                                    )}
                                </div>
                            )}
                            options={options}
                        />
                    </div>



                </div>
            </Modal >
        </>
    );
};

export default SavedReport;
